import { InspectionElementDto } from '../core/api/model/inspectionElementDto';

export class InspectionElementLinkedDto {
  public inspectionElement!: InspectionElementDto;
  public childElements?: Array<InspectionElementLinkedDto> | null;
  public parentInspectionElement?: InspectionElementLinkedDto | null;
  public inspectionCategory!: InspectionElementDto;
}
